import React from 'react';
import { useSelector } from 'react-redux';

import { getCompletedChildrenItemsUuids } from 'Shared/selectors/workspace';
import CompletedItem from 'Dashboard/components/CompletedItem/CompletedItem';

type Props = {
  parentUuid: string;
  focusedItemUuid?: string;
};

function CompletedChildrensList({ parentUuid, focusedItemUuid }: Props) {
  const completedChildrensUuids = useSelector(getCompletedChildrenItemsUuids(parentUuid));

  return completedChildrensUuids.map(uuid => (
    <CompletedItem key={uuid} uuid={uuid} isFocused={focusedItemUuid === uuid} />
  ));
}

export default CompletedChildrensList;
